import { fromJS, List, Map } from 'immutable';

import { TYPE_FINANCIAL, TYPE_STRATEGIC } from './constants/common';
import constants from './constants';
import tables from './tables';

const RESEARCHER = 'researcher';
const RESEARCH_INTERN = 'researchintern';
const JUNIOR_ANALYST = 'junioranalyst';
const PROCESS_MANAGER = 'processmanager';
const ANALYST_ASSOCIATE = 'analystassociate';
const DIRECTOR = 'director';
const FINANCE_ADMIN = 'financeadmin';
const ADMINISTRATOR = 'superuser';

// Static values
const config = {
  appName: 'Harvey CRM',
  color: '#f5b300',
  tables: {
    fund: {
      buyer: {
        columnDefs: tables.fund.buyer,
      },
    },
    contactBuyer: tables.contact.buyer,
    contactTarget: tables.contact.target,
    tradeShowCompaniesTable: {
      columnDefs: tables.tradeshow.companies,
    },
    companyExecutive: {
      columnDefs: [
        { headerName: 'Contact', field: 'dsplContactFLName', width: 100 },
        { headerName: 'Pri. Phone', field: 'dsplPhone', width: 100 },
        { headerName: 'Pri. Email', field: 'dsplEmail', width: 100 },
        {
          headerName: 'Current Status',
          field: 'execCurrentStatus',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'High Status',
          field: 'execHighStatus',
          width: 100,
          suppressSizeToFit: true,
        },
        { headerName: 'Title', field: 'title', width: 50 },
        {
          headerName: 'Start Year',
          field: 'startYear',
          width: 70,
          suppressSizeToFit: true,
        },
        {
          headerName: 'End Year',
          field: 'endYear',
          width: 70,
          suppressSizeToFit: true,
        },
        { headerName: 'Primary Industry', field: '', width: 50 },
        { headerName: 'Primary Buyer', field: '', width: 50 },
        {
          headerName: 'Quality',
          field: 'dsplQuality',
          width: 60,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Interest',
          field: 'dsplInterest',
          width: 60,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Relationship',
          field: 'dsplRelationship',
          width: 90,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Resume',
          field: 'dsplLegacyResume',
          width: 70,
          suppressSizeToFit: true,
        },
        { headerName: 'Harvco Visit', field: '', width: 50 },
        { headerName: 'Employment', field: '', width: 50 },
      ],
    },
    companyLP: {
      columnDefs: [
        { headerName: 'Name', field: 'fLName', width: 100 },
        {
          headerName: 'Primary Relationship',
          field: 'lpPrimaryRelUserName',
          width: 100,
        },
        {
          headerName: 'Current Status',
          field: 'lpCurrentStatus',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'High Status',
          field: 'lpHighStatus',
          width: 100,
          suppressSizeToFit: true,
        },
        { headerName: 'Notes', field: 'lpNotes', width: 50 },
      ],
    },
    companyTradeGroups: {
      columnDefs: [
        {
          headerName: 'Name',
          field: 'name',
          width: 300,
        },
        {
          headerName: '',
          children: [
            {
              headerName: 'Abbr.',
              field: 'abbr',
              width: 200,
              sortable: false,
            },
          ],
        },
        {
          headerName: 'Website',
          field: 'website',
          width: 300,
        },
        {
          headerName: 'Date',
          children: [
            {
              field: 'startDate',
              width: 80,
              sortable: true,
            },
            {
              field: 'endDate',
              width: 80,
              sortable: true,
            },
          ],
        },
        {
          headerName: 'Location',
          children: [
            {
              field: 'city',
              width: 100,
              sortable: true,
            },
            {
              field: 'state',
              width: 60,
              sortable: true,
            },
          ],
        },
        {
          headerName: 'Targets',
          field: 'targets',
          width: 60,
        },
        {
          headerName: '',
          children: [
            {
              field: 'total',
              width: 60,
              sortable: false,
            },
          ],
        },
      ],
    },
    companyBuyerLeads: {
      columnDefs: [
        {
          headerName: 'Curr',
          field: 'currentStatus',
          width: 100,
          suppressSizeToFit: true,
          sort: 'desc',
        },
        {
          headerName: 'High',
          field: 'highStatus',
          width: 100,
          suppressSizeToFit: true,
        },
        { headerName: 'Target', field: 'dsplTargetLegalName', width: 100 },
        { headerName: 'Project', field: 'dsplProjectCategory', width: 110 },
        {
          headerName: 'Approval List',
          field: 'applistLabel',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Priority',
          field: 'priority',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Approved',
          field: 'approved',
          width: 100,
          suppressSizeToFit: true,
        },
        { headerName: 'Industry', field: 'dsplIndustry', width: 50 },
        { headerName: 'City', field: 'dsplCity', width: 50 },
        {
          headerName: 'State',
          field: 'dsplState',
          width: 50,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Revenue',
          field: 'dsplRevenue',
          width: 100,
          suppressSizeToFit: true,
        },
      ],
    },
    companyBuyerProjects: {
      platform: {
        columnDefs: [
          { headerName: 'Category', field: 'category', width: 200 },
          { headerName: 'Active', field: 'active', width: 30 },
          { headerName: 'Harvco Lead', field: 'dsplHarvcoLeadUserName', width: 40 },
          { headerName: 'Executive', field: 'dsplExecFLName', width: 40 },
          { headerName: '# Targets.', field: 'dsplTargetCount', width: 80, suppressSizeToFit: true },
          { headerName: '# Approved', field: 'dsplApprovedCount', width: 80, suppressSizeToFit: true },
          { headerName: '% Approved', field: 'dsplApprovedPercent', width: 80, suppressSizeToFit: true },
          { headerName: 'Contacted #(%)', field: 'numberOfContacted', width: 95, suppressSizeToFit: true },
          { headerName: 'Leads #(%)', field: 'numberOfLeads', width: 80, suppressSizeToFit: true },
          { headerName: 'CC #(%)', field: 'numberOfCc', width: 70, suppressSizeToFit: true },
          { headerName: 'Visit #(%)', field: 'numberOfVisit', width: 80, suppressSizeToFit: true },
          { headerName: 'Offers #(%)', field: 'numberOfOffers', width: 80, suppressSizeToFit: true },
          { headerName: 'LOIs #(%)', field: 'numberOfLois', width: 80, suppressSizeToFit: true },
          { headerName: 'Closed #(%)', field: 'numberOfClosed', width: 80, suppressSizeToFit: true },
        ],
      },
      addon: {
        columnDefs: [
          { headerName: 'Buyer', field: 'dsplBuyerLegalName', width: 150 },
          { headerName: 'Harvco Lead', field: 'dsplHarvcoLeadUserName', width: 40 },
          { headerName: '# Targets.', field: 'dsplTargetCount', width: 100, suppressSizeToFit: true },
          { headerName: '# Approved', field: 'dsplApprovedCount', width: 100, suppressSizeToFit: true },
          { headerName: '% Approved', field: 'dsplApprovedPercent', width: 100, suppressSizeToFit: true },
          { headerName: 'Contacted #(%)', field: 'numberOfContacted', width: 100, suppressSizeToFit: true },
          { headerName: 'Leads #(%)', field: 'numberOfLeads', width: 100, suppressSizeToFit: true },
          { headerName: 'CC #(%)', field: 'numberOfCc', width: 100, suppressSizeToFit: true },
          { headerName: 'Visit #(%)', field: 'numberOfVisit', width: 100, suppressSizeToFit: true },
          { headerName: 'Offers #(%)', field: 'numberOfOffers', width: 80, suppressSizeToFit: true },
          { headerName: 'LOIs #(%)', field: 'numberOfLois', width: 80, suppressSizeToFit: true },
          { headerName: 'Closed #(%)', field: 'numberOfClosed', width: 80, suppressSizeToFit: true },
        ],
      },
    },
    companyBuyerCEO: {
      currentExecutiveLeads: {
        columnDefs: [
          { headerName: 'Name', field: 'dsplExecFLName', width: 150 },
          { headerName: 'Current Status', field: 'currentStatus', width: 40 },
          { headerName: 'High Status', field: 'highStatus', width: 40 },
          { headerName: 'Project', field: 'dsplEprojectCategory', width: 60 },
        ],
      },
      activeProjects: {
        columnDefs: [
          {
            headerName: 'Project Name',
            field: 'category.value',
            width: 100,
          },
          {
            headerName: 'Project Type',
            field: 'projectType',
            width: 80,
          },
          {
            headerName: 'Industry',
            field: 'industries',
            width: 80,
          },
          {
            headerName: 'Harvco Lead',
            field: 'dsplHarvcoLeadUserName.value',
            width: 70,
          },
          {
            headerName: 'Client Lead',
            field: 'dsplClientLeadFLName.value',
            width: 60,
          },
          {
            headerName: 'Status',
            field: 'status.value',
            width: 60,
          },
        ],
      },
    },
    leadsReport: {
      columnDefs: tables.leadsreport.companies,
    },
    userList: {
      columns: tables.user.columns,
    },
    project: {
      target: tables.project.target,
      targetBuyer: tables.project.targetBuyer,
      approval: tables.project.approval,
      approvalFinancial: tables.project.approvalFinancial,
      approvalListIds: tables.project.approvalListIds,
    },
    eproject: {
      universe: tables.eproject.universe,
      targetBuyer: tables.eproject.targetBuyer,
    },
    nextaction: {
      action: tables.nextaction.action,
    },
    companyTarget: {
      columns: [
        { title: 'Curr', field: 'curr' },
        { title: 'High', field: 'high' },
        { title: 'Target', field: 'target' },
        { title: 'App List', field: 'appList' },
        { title: 'Pri', field: 'pri' },
        { title: 'Approved', field: 'approved' },
        { title: 'Revenue', field: 'revenue' },
        { title: 'Employees', field: 'employees' },
        { title: 'EBITDA', field: 'ebitda' },
        { title: 'City', field: 'city' },
        { title: 'State', field: 'state' },
        { title: 'Web', field: 'web' },
        { title: 'Harvo Lead', field: 'harvoLead' },
      ],
    },
    approval: {
      associate: tables.approval.associate,
      online: tables.approval.online,
      recipients: tables.approval.recipients,
    },
    backlog: {
      columns: tables.backlog.columns,
    },
  },
  tabs: {
    contact: [
      {
        name: 'TARGET',
        key: 'target',
        to: '/contact/:contactId/target',
        className: 'nav-tab__target',
      },
      {
        name: 'BUYER',
        key: 'buyer',
        to: '/contact/:contactId/buyer',
        className: 'nav-tab__buyer',
      },
      {
        name: 'EXECUTIVE',
        key: 'exec',
        to: '/contact/:contactId/executive',
        className: 'nav-tab__executive',
      },
      {
        name: 'LP',
        key: 'lp',
        to: '/contact/:contactId/lp',
        className: 'nav-tab__lp',
      },
    ],
    browse: [
      { name: 'Targets', to: '/browse/targets' },
      { name: 'Buyers', to: '/browse/buyers' },
      { name: 'Executives', to: '/browse/executives' },
      { name: 'Projects', to: '/browse/projects' },
    ],
    company: [
      {
        name: 'TARGET',
        key: 'target',
        to: '/company/:companyId/target',
        className: 'nav-tab__target',
      },
      {
        name: 'BUYER',
        key: 'buyer',
        to: '/company/:companyId/buyer',
        className: 'nav-tab__buyer',
      },
      {
        name: 'EXECUTIVE',
        key: 'exec',
        to: '/company/:companyId/executive',
        className: 'nav-tab__executive',
      },
      {
        name: 'TRADE GROUPS',
        key: 'trade-groups',
        to: '/trade-groups',
        className: 'nav-tab__tradeGroups',
      },
    ],
    directorDashboard: [
      { name: 'Benchmarks', to: '/director-dashboard/benchmarks', access: [ADMINISTRATOR, FINANCE_ADMIN, DIRECTOR] },
      {
        name: 'Statistic Report',
        to: '/director-dashboard/statistic-report',
        access: [
          ADMINISTRATOR,
          FINANCE_ADMIN,
          DIRECTOR,
          ANALYST_ASSOCIATE,
          PROCESS_MANAGER,
          JUNIOR_ANALYST,
          RESEARCH_INTERN,
        ],
      },
      {
        name: 'Project Report',
        to: '/director-dashboard/project-report',
        access: [
          ADMINISTRATOR,
          FINANCE_ADMIN,
          DIRECTOR,
          ANALYST_ASSOCIATE,
          PROCESS_MANAGER,
          JUNIOR_ANALYST,
          RESEARCH_INTERN,
        ],
      },
    ],
  },
  values: {
    companyTypes: [
      { value: 'Private', name: 'Private' },
      { value: 'DivPri', name: 'DivPri' },
      { value: 'LBO', name: 'LBO' },
      { value: 'DivLBO', name: 'DivLBO' },
      { value: 'Public', name: 'Public', hasTicker: true },
      { value: 'DivPub', name: 'DivPub' },
      { value: 'VC', name: 'VC' },
      { value: 'DivVC', name: 'DivVC' },
      { value: 'ESOP', name: 'ESOP' },
      { value: 'NFP', name: 'NFP' },
      { value: 'DivNFP', name: 'DivNFP' },
      { value: 'Gov', name: 'Gov' },
      { value: 'JV', name: 'JV' },
      { value: 'ForPri', name: 'ForPri' },
      { value: 'ForPub', name: 'ForPub', hasTicker: true },
      { value: 'DivFor', name: 'DivFor' },
    ],
    contact: {
      vCardUrl: '/api/v1/people/:contactId/vcard/',
      prefixes: constants.contact.prefixes,
      suffixes: constants.contact.suffixes,
      footerDropDown: [
        {
          name: 'New Target',
          onClickField: 'onNewTarget',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'New Buyer',
          onClickField: 'onNewBuyer',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'New Executive',
          onClickField: 'onNewExecutive',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'New LP',
          onClickField: 'onNewLp',
          attributes: { 'aria-hidden': 'true' },
        },
        { name: 'Delete', onClickField: 'onDelete', attributes: { href: '#', isDanger: true } },
      ],
    },
    contactExecutive: {
      status: constants.contact.executiveStatuses,
      quality: constants.contact.executiveQualities,
      interest: constants.contact.executiveInterests,
      relation: constants.contact.executiveRelations,
      qualitiesOfExecutive: constants.contact.executiveCheckboxes,
    },
    contactLP: {
      statuses: constants.contact.lpStatuses,
    },
    targetCompany: {
      companyTypes: [
        { name: 'Mustard', attributes: {} },
        { name: 'Ketchup', attributes: {} },
        { name: 'Relish', attributes: {} },
      ],
      companyStates: [
        { name: 'SK', attributes: {} },
        { name: 'CA', attributes: {} },
        { name: 'MI', attributes: {} },
      ],
    },
    company: {
      emailTemplate: constants.company.emailTemplate,
      statuses: constants.company.targetStatuses,
      buyerStatuses: constants.company.buyerStatuses,
      tickerExchange: constants.company.tickerExchange,
      footerDropDown: [
        {
          name: 'New Target',
          onClickField: 'onNewTarget',
          attributes: { 'aria-hidden': 'true' },
          key: 'target',
        },
        {
          name: 'New Buyer',
          onClickField: 'onNewBuyer',
          attributes: { 'aria-hidden': 'true' },
          key: 'buyer',
        },
        {
          name: 'New Executive',
          onClickField: 'onNewExecutive',
          attributes: { 'aria-hidden': 'true' },
          key: 'exec',
        },
        {
          name: 'New LP',
          onClickField: 'onNewLp',
          attributes: { 'aria-hidden': 'true' },
          key: 'lp',
        },
        {
          name: 'Delete',
          onClickField: 'onDelete',
          attributes: { href: '#', isDanger: true },
          key: 'del',
        },
      ],
    },
    project: {
      types: constants.project.types,
      modes: constants.project.modes,
    },
    eproject: {
      types: constants.eproject.types,
      modes: constants.eproject.modes,
    },
    search: {
      menu: constants.search.menu,
    },
    approval: {
      naPopup: constants.approval.naPopup,
    },
  },
  main: {
    offersAndBetterReport: '/api/v1/reports/offers_and_better/',
    retainerReport: '/api/v1/reports/retainer/',
    leadsAndBetterReport: '/api/v1/reports/leads_and_better/',
    CCVisitReport: '/api/v1/reports/cc_visit/',
    OutreachReport: '/api/v1/reports/outreach/',
    CeoOutreachReport: '/api/v1/reports/ceo_outreach/',
    activityReport: '/api/v1/reports/activity/',
    conflictReport: '/api/v1/reports/conflict/',
    scraperExtensionLink: '/api/v1/scraper/download_link',
    retainerHealth: '/api/v1/reports/retainer_health/',
    header: {
      title: 'Saritasa user',
      buttons: [
        {
          title: 'Stats',
          action: 'stats',
          icon: 'cog',
          type: 'dropdown',
          id: 'downloadDropdown',
          to: '#downloadDropdown',
          elements: [
            {
              title: 'Download CC/Visits Report',
              onClickField: 'onCCVisitsReport',
              type: 'link',
              to: '/',
            },
            {
              title: 'Download Offers & Better Report',
              target: '_blank',
              href: '/api/v1/reports/offers_and_better',
              download: true,
            },
          ],
        },
        {
          title: 'Add user',
          to: 'user',
          icon: 'plus',
          type: 'link',
          target: '_blank',
        },
        {
          title: 'Next Actions',
          to: 'next-actions',
          icon: 'flag',
          type: 'link',
          target: '_blank',
        },
        {
          title: 'Backlog',
          to: 'mailing-backlog',
          icon: 'clock-o',
          type: 'link',
          target: '_blank',
        },
      ],
    },
    controls: {
      search: {
        buttonText: 'Search',
        inputText: 'browse/query',
      },
      dropdown: {
        text: 'Show/Hide',
        elements: [
          {
            key: 'researches',
            name: 'Research',
            access: [ADMINISTRATOR, DIRECTOR, JUNIOR_ANALYST, FINANCE_ADMIN, RESEARCH_INTERN],
          },
          { key: 'backlog', name: 'Backlog' },
          { key: 'tc1', name: 'C1s (T)' },
          { key: 'ttl', name: 'Top Leads (T)' },
          { key: 'tcna', name: 'Custom Next Actions (T)' },
          { key: 'tcp', name: 'Current Projects (T)' },
          { key: 'tmtd', name: 'MTD CCs & Visits (T)' },
          { key: 'trc', name: 'Recently Called (T)' },
          { key: 'ecall', name: 'Calls (E)' },
          { key: 'eemail', name: 'Emails (E)' },
          { key: 'ecna', name: 'Custom Next Actions (E)' },
          { key: 'emtdstats', name: 'MTD CCs & Visits (E)' },
          { key: 'etl', name: 'Top Leads (E)' },
          { key: 'erc', name: 'Recently Called (E)' },
          {
            key: 'pd',
            name: 'Deletion Requests',
            access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN],
          },
          { key: 'sp', name: 'Saved Browse/Queries' },
          { key: 'meetings', name: 'Meetings' },
        ],
      },
    },
    widgets: {
      researches: {
        title: 'Research',
        columns: [
          { headerName: 'Date', field: 'date', width: 80 },
          { headerName: 'Profile Type', field: 'profileType', width: 120 },
          { headerName: 'Company', field: 'legalName', width: 200 },
          { headerName: 'Website', field: 'web', width: 360 },
          { headerName: 'Project', field: 'project', width: 100 },
          { headerName: 'Rev/Emp', field: 'revenueEmployees', width: 100 },
          { headerName: 'User', field: 'userName', width: 100 },
          { headerName: 'Cur/Hi', field: 'currentHighStatuses', width: 80 },
          { headerName: 'DM1', field: 'dm1', width: 80 },
          { headerName: 'DM2', field: 'dm2', width: 80 },
        ],
      },
      backlog: {
        urlTemplate: '/backlog',
        title: 'Backlog',
        columns: [
          { headerName: '#', field: '#', width: 25 },
          {
            headerName: 'Primary DM',
            field: 'recordOwnerUserName',
            width: 100,
          },
          {
            headerName: 'Secondary DM',
            field: 'recordSubOwnerUserName',
            width: 100,
          },
          { headerName: 'Buyer', field: 'buyerLegalName', width: 250 },
          { headerName: 'Project', field: 'projectCategory', width: 160 },
          { headerName: 'Next Action', field: 'activity', width: 80 },
          { headerName: 'Quantity', field: 'targetCount', width: 70 },
        ],
      },
      tc1: {
        urlTemplate: '/company/:targetId/',
        title: 'C1s (T)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Company', field: 'targetLegalName' },
          { headerName: 'Buyer', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'projectCategory' },
          { headerName: 'Priority', field: 'priority' },
          { headerName: 'City', field: 'targetCity' },
          { headerName: 'State', field: 'targetState' },
          { headerName: 'User', field: 'userName' },
        ],
      },
      ttl: {
        urlTemplate: '/company/:entityId/',
        title: 'Top Leads (T)',
        columns: [
          { headerName: 'Current', field: 'targetCurrentStatus' },
          { headerName: 'Company', field: 'legalName' },
          { headerName: 'Buyer', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'projectCategory' },
          { headerName: 'Revenue', field: 'revenue' },
          { headerName: 'Next Action Date', field: 'naDate' },
          { headerName: 'Next Action', field: 'naActivity' },
        ],
      },
      tcna: {
        urlTemplate: '/company/:targetId/',
        title: 'Custom Next Actions (T)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Company', field: 'targetLegalName' },
          { headerName: 'Next Action', field: 'activity' },
          { headerName: 'Buyer', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'projectCategory' },
          { headerName: 'Priority', field: 'priority' },
        ],
      },
      pd: {
        title: 'Deletion Requests',
        selectedIds: [],
        columns: [
          { headerName: '', field: 'selected', width: 36, suppressSizeToFit: true },
          { headerName: 'Company', field: 'companyLegalName' },
          { headerName: 'Date', field: 'date' },
          { headerName: 'Requested By', field: 'userFullName' },
        ],
      },
      sp: {
        title: 'Saved Browse/Queries',
        columns: [
          { headerName: 'Query Name', field: 'name' },
          { headerName: 'Type', field: 'type' },
          { headerName: 'Date', field: 'createdAt', width: 85 },
          { headerName: 'Actions', field: 'actions', width: 300, minWidth: 280 },
        ],
      },
      meetings: {
        title: 'Meetings',
        columns: [
          { headerName: 'Date', field: 'meetingDateTime', minWidth: 120 },
          { headerName: 'Description', field: 'title', minWidth: 140, sortable: false },
          { headerName: 'Harvey Users', field: 'users', minWidth: 140, sortable: false },
          { headerName: 'Participants', field: 'participants', minWidth: 140, sortable: false },
          { headerName: 'Proposed Company', field: 'companies', minWidth: 140, sortable: false },
          { headerName: 'Proposed Event Type', field: 'eventType', width: 140, minWidth: 140, sortable: false },
          { headerName: 'Detailed Notes', field: 'meetingLink', width: 100, minWidth: 100, sortable: false },
          { headerName: 'Expiration Date', field: 'expiresAt', minWidth: 120, sortable: false },
          { headerName: '', field: 'actions', width: 34, sortable: false },
        ],
      },
      tcp: {
        urlTemplate: '/project/:projectId/',
        title: 'Current Projects (T)',
        columns: [
          { headerName: 'Client', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'category' },
          { headerName: 'Type', field: 'type' },
          { headerName: 'Last List', field: 'date' },
          { headerName: 'Targets', field: 'targets' },
          { headerName: 'Leads', field: 'leads' },
          { headerName: 'C#(%)', field: 'percentOfContacted' },
          { headerName: 'NAs', field: 'nextActionCount' },
          { headerName: 'Users', field: 'users' },
        ],
      },
      tmtd: {
        title: 'MTD CCs & Visits (T)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Activity', field: 'activity' },
          { headerName: 'Company', field: 'targetLegalName' },
          { headerName: 'Buyer', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'projectCategory' },
        ],
      },
      trc: {
        urlTemplate: '/company/:targetId/',
        title: 'Recently Called (T)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Company', field: 'targetLegalName' },
          { headerName: 'Buyer', field: 'buyerLegalName' },
          { headerName: 'Project', field: 'projectCategory' },
          { headerName: 'Priority', field: 'priority' },
        ],
      },
      ecall: {
        urlTemplate: '/contact/:execId/',
        title: 'Calls (E)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Name', field: 'execFLName' },
          { headerName: 'Current', field: 'execCurrentStatus' },
          { headerName: 'High', field: 'execHighStatus' },
          { headerName: 'Company', field: 'execCompanyLegalName' },
        ],
      },
      eemail: {
        urlTemplate: '/contact/:execId/',
        title: 'Emails (E)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Name', field: 'execFLName' },
          { headerName: 'Current', field: 'execCurrentStatus' },
          { headerName: 'High', field: 'execHighStatus' },
          { headerName: 'Company', field: 'execCompanyLegalName' },
        ],
      },
      ecna: {
        urlTemplate: '/contact/:execId/',
        title: 'Custom Next Actions (E)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Activity', field: 'activity' },
          { headerName: 'Name', field: 'execFLName' },
          { headerName: 'Current', field: 'execCurrentStatus' },
          { headerName: 'High', field: 'execHighStatus' },
          { headerName: 'Company', field: 'execCompanyLegalName' },
        ],
      },
      emtdstats: {
        urlTemplate: '/contact/:execId/',
        title: 'MTD CCs & Visits (E)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Activity', field: 'activity' },
          { headerName: 'Name', field: 'execFLName' },
        ],
      },
      etl: {
        urlTemplate: '/contact/:contactId/',
        title: 'Top Leads (E)',
        columns: [
          { headerName: 'Current', field: 'execCurrentStatus' },
          { headerName: 'High', field: 'execHighStatus' },
          { headerName: 'Name', field: 'execFLName' },
          { headerName: 'Fund', field: 'fundLegalName' },
          { headerName: 'Project', field: 'eprojectCategory' },
        ],
      },
      erc: {
        urlTemplate: '/contact/:execId/',
        title: 'Recently Called (E)',
        columns: [
          { headerName: 'Date', field: 'date' },
          { headerName: 'Name', field: 'execFLName' },
          { headerName: 'Current', field: 'execCurrentStatus' },
          { headerName: 'High', field: 'execHighStatus' },
          { headerName: 'Company', field: 'execCompanyLegalName' },
        ],
      },
    },
  },
  search: {
    controls: {
      buttonText: 'Search',
      inputText: 'Enter search searchingTerm...',
    },
  },
  browse: {
    table: {
      columnDefs: {
        targetsCustom: [
          { headerName: '', field: 'selected', width: 36, suppressSizeToFit: true },
          { headerName: 'Name', field: 'targetName', width: 180 },
          { headerName: 'Buyer', field: 'buyerName', width: 100 },
          { headerName: 'Current Status', field: 'currentStatus', width: 70, sort: 'desc' },
          { headerName: 'High Status', field: 'highStatus', width: 60 },
          { headerName: 'Revenue', field: 'revenue', width: 45 },
          { headerName: 'EBITDA', field: 'ebitda', width: 45 },
          { headerName: 'State', field: 'state', width: 40 },
          { headerName: 'Next Action Date', field: 'nextActionDate', width: 80 },
          { headerName: 'Next Action', field: 'nextAction', width: 80 },
          { headerName: 'Last Action Date', field: 'lastActionDate', width: 80 },
          { headerName: 'Last Action', field: 'lastAction', width: 80 },
          { headerName: 'Description', field: 'description', width: 125 },
          { headerName: 'Module', field: 'directorName', width: 70 },
          { headerName: 'A/A', field: 'analystName', width: 80 },
        ],
        targets: [
          { headerName: '', field: 'selected', width: 36, suppressSizeToFit: true },
          { headerName: 'Name', field: 'targetName', width: 180 },
          { headerName: 'Curr', field: 'currentStatus', width: 60 },
          { headerName: 'High', field: 'highStatus', width: 40 },
          { headerName: 'Module', field: 'directorName', width: 70 },
          { headerName: 'DM1', field: 'analystName', width: 70 },
          { headerName: 'DM2', field: 'dealMaker2', width: 70 },
          { headerName: 'Buyer', field: 'buyerName', width: 70 },
          {
            headerName: 'Project',
            field: 'projectName',
            renderType: 'projectGroup',
            width: 110,
          },
          { headerName: 'Approval list', field: 'approvalListName', width: 50 },
          { headerName: 'Pri.', field: 'priority', width: 50 },
          { headerName: 'Approved', field: 'approved', width: 72 },
          { headerName: 'Revenue', field: 'revenue', width: 38 },
          { headerName: 'Employees', field: 'employees', width: 60 },
          { headerName: 'EBITDA', field: 'ebitda', width: 45 },
          { headerName: 'Type', field: 'companyType', width: 70 },
          { headerName: 'Parent', field: 'parentName', width: 100 },
          { headerName: 'City', field: 'city', width: 90 },
          { headerName: 'State', field: 'state', width: 40 },
          { headerName: 'Country', field: 'countryAbbr', width: 80 },
          { headerName: 'Industry', field: 'industryCategory', width: 80 },
          {
            headerName: 'Next Action Date',
            field: 'nextActionDate',
            width: 80,
          },
          { headerName: 'Next Action', field: 'nextAction', width: 80 },
          {
            headerName: 'Last Action Date',
            field: 'lastActionDate',
            width: 80,
          },
          { headerName: 'Last Action', field: 'lastAction', width: 80 },
          { headerName: 'Description', field: 'description', width: 125 },
        ],
        buyers: [
          { headerName: '', field: 'selected', width: 36, suppressSizeToFit: true },
          { headerName: 'Name', field: 'buyerName', width: 150 },
          { headerName: 'Curr', field: 'currentStatus', width: 60 },
          { headerName: 'High', field: 'highStatus', width: 40 },
          { headerName: 'B. Type', field: 'buyerType', width: 60 },
          { headerName: 'Co. Type', field: 'companyType', width: 60 },
          { headerName: 'Pri.', field: 'priority', width: 40 },
          {
            headerName: 'HarvCo Contact',
            field: 'buyerHarvcoLeadUserName',
            width: 80,
          },
          { headerName: 'City', field: 'city', width: 80 },
          { headerName: 'State', field: 'state', width: 40 },
          { headerName: '# Targets.', field: 'numberOfTargets', width: 60 },
          {
            headerName: '# Approved',
            field: 'numberOfApprovedTargets',
            width: 60,
          },
          { headerName: '% Approved', field: 'approvedPercent', width: 60 },
          { headerName: '# Mailed', field: 'numberOfMailedTargets', width: 60 },
          { headerName: '% Mailed', field: 'mailedPercent', width: 60 },
          { headerName: '# Called', field: 'numberOfCalledTargets', width: 70 },
          { headerName: '% Called', field: 'calledPercent', width: 60 },
          { headerName: 'Parent', field: 'nameOfParentCompany', width: 100 },
          {
            headerName: 'Next Action Date',
            field: 'nextActionDate',
            width: 100,
          },
          { headerName: 'Next Action', field: 'nextAction', width: 100 },
          {
            headerName: 'Last Action Date',
            field: 'lastActionDate',
            width: 100,
          },
          { headerName: 'Last Action', field: 'lastAction', width: 100 },
        ],
        executives: [
          {
            headerName: '',
            field: 'selected',
            width: 36,
            suppressSizeToFit: true,
          },
          { headerName: 'Last Name', field: 'lastName', width: 90 },
          { headerName: 'First Name', field: 'firstName', width: 90 },
          { headerName: 'Nick Name', field: 'nick', width: 90 },
          { headerName: 'Curr', field: 'currentStatus', width: 60 },
          { headerName: 'High', field: 'highStatus', width: 40 },
          { headerName: 'Analyst/Assoc.', field: 'analyst', width: 70 },
          { headerName: 'Fund', field: 'fundName', width: 70 },
          { headerName: 'Project', field: 'projectName', width: 110 },
          { headerName: 'Industry', field: 'industryCategory', width: 110 },
          { headerName: 'Employed', field: 'employed', width: 35 },
          { headerName: 'Age', field: 'age', width: 30 },
          { headerName: 'Q', field: 'quality', width: 40 },
          { headerName: 'I', field: 'interest', width: 40 },
          { headerName: 'R', field: 'relationship', width: 40 },
          { headerName: 'Resume', field: 'resume', width: 35 },
          { headerName: 'Needs Fund', field: 'needsFund', width: 35 },
          { headerName: 'Next Step', field: 'nextStep', width: 80 },
          { headerName: 'Last Researched', field: 'lastResearched', width: 80 },
          {
            headerName: 'Last Researched Date',
            field: 'lastResearchedDate',
            width: 80,
          },
          {
            headerName: 'Next Action Date',
            field: 'nextActionDate',
            width: 80,
          },
          { headerName: 'Next Action', field: 'nextAction', width: 80 },
          {
            headerName: 'Last Action Date',
            field: 'lastActionDate',
            width: 80,
          },
          { headerName: 'Last Action', field: 'lastAction', width: 94 },
          { headerName: 'Deal Notes', field: 'dealNotes', width: 95 },
        ],
        projects: [
          { headerName: 'Buyer', field: 'buyerName', width: 400 },
          { headerName: 'Category', field: 'category', width: 300 },
          { headerName: 'HarvCo Lead', field: 'harvcoLead', width: 150 },
          { headerName: '# Targets', field: 'targetNumber', width: 150 },
          {
            headerName: 'Current App. List',
            field: 'curApprovalListName',
            width: 150,
          },
          { headerName: 'Details', field: 'details', width: 242 },
          { headerName: 'Status', field: 'status', width: 150 },
        ],
      },
    },
    filter: {
      targets: {
        currentStatus: {
          label: 'Current Status',
          name: 'currentStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        highStatus: {
          label: 'High Status',
          name: 'highStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        revenue: {
          label: 'Revenue',
          name: 'revenue',
          minValue: 0,
          maxValue: 500,
          step: 1,
        },
        ebitda: {
          label: 'EBITDA',
          name: 'ebitda',
          minValue: 0,
          maxValue: 500,
          step: 1,
        },
        employees: {
          label: 'Employees',
          name: 'employees',
        },
        states: {
          label: 'States',
          name: 'states',
          state: {
            inputLabel: 'State',
            placeholder: 'Select state',
            name: 'state',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'state',
            renderField: 'state',
            keepText: true,
          },
          city: {
            inputLabel: 'City',
            placeholder: 'Select city',
            name: 'city',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'city',
            renderField: 'city',
            keepText: true,
          },
        },
        country: {
          label: 'Country',
          name: 'country',
          placeholder: 'Country',
          valueField: 'id',
          renderField: 'text',
        },
        module: {
          label: 'Module',
          name: 'module',
          valueField: 'id',
          renderField: 'text',
        },
        analyst: {
          label: 'Dealmaker 1',
          name: 'analyst',
          valueField: 'id',
          renderField: 'text',
        },
        dealMaker2: {
          label: 'Dealmaker 2',
          name: 'dealMaker2',
          valueField: 'id',
          renderField: 'text',
        },
        researcher: {
          label: 'Researcher',
          name: 'researcher',
          valueField: 'id',
          renderField: 'text',
          filters: [
            { name: 'isNewProfile', title: 'New Profile' },
            { name: 'isUpdatedProfile', title: 'Updated Profile' },
            { name: 'isConfirmedProfile', title: 'Confirmed Profile' },
          ],
        },
        buyer: {
          label: 'Buyer',
          name: 'buyer',
          buyer: {
            inputLabel: 'Buyer',
            name: 'buyer',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'id',
            renderField: 'text',
            keepText: true,
          },
          currentStatus: {
            label: 'Current Status',
            name: 'currentStatus',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          highStatus: {
            label: 'High Status',
            name: 'highStatus',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          project: {
            inputLabel: 'Project',
            name: 'project',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'id',
            renderField(suggestion) {
              return `${suggestion.category} (${suggestion.harvcoLead})`;
            },
            keepText: true,
          },
          approval: {
            inputLabel: 'Approval list',
            name: 'approval',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'id',
            renderField: 'text',
            keepText: true,
          },
          priority: {
            inputLabel: 'Priority',
            name: 'priority',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'value',
            renderField: 'name',
            keepText: true,
          },
          approved: [
            { name: '', value: '', attributes: {} },
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
            { name: 'No Response', value: 'No Response', attributes: {} },
          ],
        },
        harvcoTags: {
          label: 'HarvCo Tags',
          name: 'harvcoTags',
          valueField: 'id',
          renderField: 'value',
        },
        industry: {
          label: 'Industry',
          name: 'industry',
          valueField: 'id',
          renderField: 'text',
        },
        nextAction: {
          label: 'Next Action',
          name: 'nextAction',
          eventActivity: {
            name: 'nextAction',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
        },
        lastAction: {
          label: 'Activity',
          name: 'lastAction',
          eventActivity: {
            name: 'lastAction',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
          statusChanged: false,
          statusChangedFrom: {
            label: 'From',
            name: 'statusChangedFrom',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          statusChangedTo: {
            label: 'To',
            name: 'statusChangedTo',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          users: {
            label: 'Users',
            name: 'users',
            placeholder: 'Completed By',
            valueField: 'id',
            renderField: 'text',
          },
          buyers: {
            label: 'Active Buyer',
            name: 'buyers',
            placeholder: 'Active Buyer',
            valueField: 'id',
            renderField: 'text',
          },
        },
        description: {
          label: 'Description',
          name: 'description',
          valueField: 'id',
          renderField: 'value',
        },
        companyType: {
          label: 'Company Type',
          name: 'companyType',
          valueField: 'id',
          renderField: 'value',
        },
        areaCode: {
          label: 'Area Code',
          name: 'areaCode',
          valueField: 'id',
          renderField: 'value',
        },
        keywords: {
          label: 'Keywords',
          name: 'keywords',
          description:
            'searches description, research notes, deal notes, email log, products, markets, industries and HarvCo tags simultaneously',
          valueField: 'id',
          renderField: 'value',
        },
        projectType: {
          label: 'Project Type',
          name: 'projectType',
          options: [
            { name: 'Platform', value: 'Platform', attributes: {} },
            { name: 'Add-on', value: 'Add-on', attributes: {} },
          ],
        },
        uploadSearch: {
          label: 'Upload Search',
          name: 'uploadSearch',
          fileType: 'xlsx',
        },
        mergeResultOnly: {
          label: 'Merge Result Only',
          name: 'mergeResultOnly',
        },
      },
      buyers: {
        buyerType: {
          label: 'Buyer Type',
          name: 'buyerType',
          financial: {
            label: TYPE_FINANCIAL,
            name: 'financial',
          },
          strategic: {
            label: TYPE_STRATEGIC,
            name: 'strategic',
          },
        },
        priority: {
          label: 'Priority',
          name: 'priority',
          valueField: 'id',
          renderField: 'value',
          enableDynamicAdd: true,
        },
        currentStatus: {
          label: 'Current Status',
          name: 'currentStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        highStatus: {
          label: 'High Status',
          name: 'highStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        projectActivity: {
          label: 'Project Activity',
          name: 'projectActivity',
          contacted: {
            label: 'Contacted (4.6+ High Status)',
            name: 'contacted',
          },
          currentLead: {
            label: 'Current Leads (5+ Status)',
            name: 'currentLead',
          },
          totalLead: {
            label: 'Total Leads (5+ High Status)',
            name: 'totalLead',
          },
          cc: {
            label: 'CCs (5.5+ High Status)',
            name: 'cc',
          },
          visit: {
            label: 'Visits (6+ High Status)',
            name: 'visit',
          },
          offer: {
            label: 'Offers (8+ High Status)',
            name: 'offer',
          },
        },
        revenue: {
          label: 'Revenue Criteria',
          name: 'revenue',
          minValue: 0,
          maxValue: 500,
          step: 1,
        },
        ebitda: {
          label: 'EBITDA Criteria',
          name: 'ebitda',
          minValue: 0,
          maxValue: 500,
          step: 1,
        },
        ev: {
          label: 'EV Criteria',
          name: 'ev',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        transactionTypes: {
          label: 'Transaction Types',
          name: 'transactionTypes',
          buyout: {
            label: 'Buyout',
            name: 'buyout',
          },
          recap: {
            label: 'Recap',
            name: 'recap',
          },
          mezz: {
            label: 'Mezz',
            name: 'mezz',
          },
          carveout: {
            label: 'Carve-Out',
            name: 'carveout',
          },
          takeprivate: {
            label: 'Take Private',
            name: 'takeprivate',
          },
          minority: {
            label: 'Minority',
            name: 'minority',
          },
          turnaround: {
            label: 'Turnaround',
            name: 'turnaround',
          },
        },
        geography: {
          label: 'Geographic Criteria',
          name: 'geography',
          description: '',
          valueField: 'id',
          renderField: 'value',
        },
        industry: {
          label: 'Industry Criteria',
          name: 'industry',
          valueField: 'id',
          renderField: 'text',
        },
        harvcoContact: {
          label: 'HarvCo Contact',
          name: 'harvcoContact',
          valueField: 'id',
          renderField: 'text',
        },
        companyType: {
          label: 'Company Type',
          name: 'companyType',
          valueField: 'id',
          renderField: 'value',
        },
        companyState: {
          label: 'States',
          name: 'companyState',
          valueField: 'id',
          renderField: 'value',
        },
        areaCode: {
          label: 'Area Code',
          name: 'areaCode',
          description: "Buyer's own phone number - not its geographic investment criteria",
          valueField: 'id',
          renderField: 'value',
        },
        nextAction: {
          label: 'Next Action',
          name: 'nextAction',
          eventActivity: {
            name: 'nextAction',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
        },
        activity: {
          label: 'Activity',
          name: 'activity',
          eventActivity: {
            name: 'activity',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
          statusChanged: false,
          statusChangedFrom: {
            label: 'From',
            name: 'statusChangedFrom',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          statusChangedTo: {
            label: 'To',
            name: 'statusChangedTo',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          users: {
            label: 'Users',
            name: 'users',
            placeholder: 'Completed By',
            valueField: 'id',
            renderField: 'text',
          },
          buyers: {
            label: 'Active Buyer',
            name: 'buyers',
            placeholder: 'Active Buyer',
            valueField: 'id',
            renderField: 'text',
          },
          buyerType: {
            label: 'Buyer Type',
            name: 'buyerType',
            options: [
              { name: TYPE_FINANCIAL, value: TYPE_FINANCIAL, attributes: {} },
              { name: TYPE_STRATEGIC, value: TYPE_STRATEGIC, attributes: {} },
            ],
          },
        },
        harvcoTags: {
          label: 'HarvCo Tags',
          name: 'harvcoTags',
          valueField: 'id',
          renderField: 'value',
        },
        country: {
          label: 'Country',
          name: 'country',
          placeholder: 'Country',
          valueField: 'id',
          renderField: 'text',
        },
        startDate: {
          label: 'Start Date',
          name: 'startDate',
          valueField: 'id',
          renderField: 'value',
        },
        endDate: {
          label: 'End Date',
          name: 'endDate',
          valueField: 'id',
          renderField: 'value',
        },
        keywords: {
          label: 'Keywords',
          name: 'keywords',
          description:
            'searches full name, abbreviated name, project scope, marketing/approach, email log of the Buyers',
          valueField: 'id',
          renderField: 'value',
        },
        mergeResultOnly: {
          label: 'Merge Result Only',
          name: 'mergeResultOnly',
        },
      },
      executives: {
        currentStatus: {
          label: 'Current Status',
          name: 'currentStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        highStatus: {
          label: 'High Status',
          name: 'highStatus',
          minValue: 0,
          maxValue: 10,
          step: 0.01,
        },
        module: {
          label: 'Module',
          name: 'module',
          valueField: 'id',
          renderField: 'text',
        },
        analyst: {
          label: 'Analyst/Associate',
          name: 'analyst',
          valueField: 'id',
          renderField: 'text',
        },
        dealmaker: {
          label: '3rd Dealmaker',
          name: 'dealmaker',
          valueField: 'id',
          renderField: 'text',
        },
        researcher: {
          label: 'Researcher',
          name: 'researcher',
          valueField: 'id',
          renderField: 'text',
        },
        fund: {
          label: 'Fund',
          name: 'fund',
          fund: {
            inputLabel: 'Fund',
            name: 'fund',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'id',
            renderField: 'text',
            keepText: true,
          },
          project: {
            inputLabel: 'Project',
            name: 'project',
            className: 'form-control',
            formGroupClass: 'form-group--inline form-group--input',
            valueField: 'id',
            renderField: 'text',
            keepText: true,
          },
        },
        harvcoTags: {
          label: 'HarvCo Tags',
          name: 'harvcoTags',
          valueField: 'id',
          renderField: 'value',
        },
        industry: {
          label: 'Industry',
          name: 'industry',
          valueField: 'id',
          renderField: 'text',
        },
        nextAction: {
          label: 'Next Action',
          name: 'nextAction',
          eventActivity: {
            name: 'nextAction',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
        },
        activity: {
          label: 'Activity',
          name: 'activity',
          eventActivity: {
            name: 'activity',
            placeholder: 'Event Activity',
            valueField: 'id',
            renderField: 'value',
            keepText: true,
          },
          statusChanged: false,
          statusChangedFrom: {
            label: 'From',
            name: 'statusChangedFrom',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          statusChangedTo: {
            label: 'To',
            name: 'statusChangedTo',
            minValue: 0,
            maxValue: 10,
            step: 0.01,
          },
          users: {
            label: 'Users',
            name: 'users',
            placeholder: 'Completed By',
            valueField: 'id',
            renderField: 'text',
          },
          buyers: {
            label: 'Active Buyer',
            name: 'buyers',
            placeholder: 'Active Buyer',
            valueField: 'id',
            renderField: 'text',
          },
        },
        areaCode: {
          label: 'Area Code',
          name: 'areaCode',
          valueField: 'id',
          renderField: 'value',
        },
        projectType: {
          label: 'Project Type',
          name: 'projectType',
          options: [
            { name: 'Platform', value: 'Platform', attributes: {} },
            { name: 'Add-on', value: 'Add-on', attributes: {} },
          ],
        },
        companyState: {
          label: 'State',
          name: 'companyState',
          valueField: 'id',
          renderField: 'value',
        },
        keywords: {
          label: 'Keywords',
          name: 'keywords',
          description:
            'searches description, research notes, deal notes, email log, products, markets, industries and HarvCo tags simultaneously',
          valueField: 'id',
          renderField: 'value',
        },
        resume: {
          label: 'Resume',
          name: 'resume',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        mbo: {
          label: 'MBO',
          name: 'mbo',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        corpBuyer: {
          label: 'Corp. Buyer',
          name: 'corpBuyer',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        needsFund: {
          label: 'Needs Fund',
          name: 'needsFund',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        peExperience: {
          label: 'PE Experience',
          name: 'peExperience',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        events: {
          label: 'Events',
          name: 'events',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        meet: {
          label: 'Meet',
          name: 'meet',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        quality: {
          label: 'Quality',
          name: 'quality',
          wcm: {
            label: '5 - WCM',
            name: 'wcm',
          },
          solid: {
            label: '4.5 - Solid Manager',
            name: 'solid',
          },
          good: {
            label: '4 - Good Manager',
            name: 'good',
          },
          goodNotVerified: {
            label: '3.9 - Good Manager (Not Verified)',
            name: 'goodNotVerified',
          },
          average: {
            label: '3 - Average Manager',
            name: 'average',
          },
          weaker: {
            label: '2 - Weaker Manager',
            name: 'weaker',
          },
          poor: {
            label: '1 - Poor Manager/Executive',
            name: 'poor',
          },
          unsure: {
            label: '0 - Quality Unsure',
            name: 'unsure',
          },
        },
        interest: {
          label: 'Interest',
          name: 'interest',
          very: {
            label: '3 - Very Interested',
            name: 'very',
          },
          somewhat: {
            label: '2 - Somewhat Interested',
            name: 'somewhat',
          },
          no: {
            label: '1 - No Interest',
            name: 'no',
          },
          unknown: {
            label: '0 - Interest Unknown',
            name: 'unknown',
          },
        },
        relationship: {
          label: 'Relationship',
          name: 'relationship',
          strong: {
            label: '3 - Strong Relationship',
            name: 'strong',
          },
          semi: {
            label: '2 - Semi-Strong Relationship',
            name: 'semi',
          },
          brief: {
            label: '1 - Brief/Limited Contact',
            name: 'brief',
          },
          no: {
            label: '0 - No Relationship',
            name: 'no',
          },
        },
        doNotMail: {
          label: 'Do Not Mail',
          name: 'doNotMail',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        employed: {
          label: 'Employed',
          name: 'employed',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
      },
      projects: {
        buyer: {
          label: 'Buyer',
          name: 'buyer',
          valueField: 'id',
          renderField: 'text',
        },
        harvcoContact: {
          label: 'Harvco Lead',
          name: 'harvcoContact',
          valueField: 'id',
          renderField: 'text',
        },
        users: {
          label: 'Users',
          name: 'users',
          valueField: 'id',
          renderField: 'text',
        },
        active: {
          label: 'Active',
          name: 'active',
          options: [
            { name: 'Yes', value: 'Yes', attributes: {} },
            { name: 'No', value: 'No', attributes: {} },
          ],
        },
        category: {
          label: 'Name',
          name: 'category',
          valueField: 'id',
          renderField: 'text',
        },
        industry: {
          label: 'Industry',
          name: 'industry',
          valueField: 'id',
          renderField: 'text',
        },
        keywords: {
          label: 'Keywords',
          name: 'keywords',
          description: 'searches project scope, geography simultaneously',
          valueField: 'id',
          renderField: 'value',
        },
        buyerProjectCriteria: {
          label: 'Default Criteria',
          name: 'buyerProjectCriteria',
          transactionTypes: {
            label: 'Transaction Types',
            name: 'transactionTypes',
            buyout: {
              label: 'Buyout',
              name: 'buyout',
            },
            recap: {
              label: 'Recap',
              name: 'recap',
            },
            mezz: {
              label: 'Mezz',
              name: 'mezz',
            },
            carveout: {
              label: 'Carve-Out',
              name: 'carveout',
            },
            takeprivate: {
              label: 'Take Private',
              name: 'takeprivate',
            },
            minority: {
              label: 'Minority',
              name: 'minority',
            },
            turnaround: {
              label: 'Turnaround',
              name: 'turnaround',
            },
          },
          revenueRange: {
            label: 'Revenue',
            name: 'revenueRange',
            minValue: 0,
            maxValue: 500,
            step: 1,
          },
          ebitdaRange: {
            label: 'EBITDA',
            name: 'ebitdaRange',
            minValue: 0,
            maxValue: 500,
            step: 1,
          },
          evRange: {
            label: 'EV',
            name: 'evRange',
            minValue: 0,
            maxValue: 500,
            step: 1,
          },
        },
      },
    },
    contextActionList: {
      targets: [
        {
          name: 'Add Tag to Selected',
          attributes: {},
          key: 'addTagToSelected',
          access: [
            RESEARCH_INTERN,
            JUNIOR_ANALYST,
            PROCESS_MANAGER,
            ANALYST_ASSOCIATE,
            DIRECTOR,
            ADMINISTRATOR,
            FINANCE_ADMIN,
          ],
        },
        {
          name: 'Add Industry Tag to Selected Targets',
          attributes: {},
          key: 'addIndustryTagToSelected',
          access: [
            RESEARCH_INTERN,
            JUNIOR_ANALYST,
            PROCESS_MANAGER,
            ANALYST_ASSOCIATE,
            DIRECTOR,
            ADMINISTRATOR,
            FINANCE_ADMIN,
          ],
        },
        {
          name: 'Assign Trade Show to Selected Targets',
          attributes: {},
          key: 'assignTradeShowToSelected',
          access: [
            RESEARCH_INTERN,
            JUNIOR_ANALYST,
            PROCESS_MANAGER,
            ANALYST_ASSOCIATE,
            DIRECTOR,
            ADMINISTRATOR,
            FINANCE_ADMIN,
          ],
        },
        {
          name: 'Set Next Action for Selected',
          attributes: {},
          key: 'setNextActionForSelected',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Push Next Action Dates for Selected',
          attributes: {},
          key: 'pushNextActionDateForSelected',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Add/Update Buyer for Selected',
          attributes: {},
          key: 'addUpdateBuyerForSelected',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Flip Selected to Different Team',
          attributes: {},
          key: 'flipSelectedToDifferentTeam',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Export Selected',
          attributes: {},
          key: 'exportSelected',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN],
        },
        {
          name: 'Delete Selected',
          attributes: { isDanger: true },
          key: 'deleteSelected',
          access: [ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN],
        },
        {
          name: 'Delete Selected',
          attributes: { isDanger: true },
          key: 'deleteConfirmationSelected',
          access: [RESEARCHER, RESEARCH_INTERN, JUNIOR_ANALYST, PROCESS_MANAGER],
        },
        {
          name: 'Backlog selected',
          attributes: {},
          key: 'backlogSelected',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Run Windward Report',
          attributes: {},
          key: 'runWindwardReport',
          access: [PROCESS_MANAGER, ANALYST_ASSOCIATE, DIRECTOR, ADMINISTRATOR, FINANCE_ADMIN, JUNIOR_ANALYST],
        },
        {
          name: 'Merge Confirm',
          attributes: {},
          key: 'mergeConfirm',
          access: [DIRECTOR, ADMINISTRATOR],
        },
      ],
      buyers: [{ name: 'Export Selected', attributes: {}, key: 'exportSelected' }],
      executives: [
        {
          name: 'Add Tag to Selected',
          attributes: {},
          key: 'addTagToSelected',
        },
        { name: 'Export Selected', attributes: {}, key: 'exportSelected' },
      ],
    },
    accesses: [
      // We use hard enum for browse page tabs access id instead request "GET: {{host}}/api/v1/users/browse_accesses" to simplify.
      { name: 'targets', title: 'Targets', key: 1 },
      { name: 'buyers', title: 'Buyers', key: 2 },
      { name: 'executives', title: 'Execs', key: 3 },
      { name: 'projects', title: 'Projects', key: 4 },
    ],
  },
  project: {
    list: {
      columns: [
        'Curr',
        'High',
        'Target',
        'App List',
        'Pri',
        'Approved',
        'Revenue',
        'Employees',
        'EBITDA',
        'City',
        'State',
        'Web',
        'Harvco Lead',
      ],
      cells: [
        4.7,
        6.0,
        'BlissLights, Inc.',
        '',
        'A',
        '',
        25,
        23,
        '',
        'Escondido',
        'CA',
        'http://www.blisslights.com/',
        'ehartley',
      ],
    },
  },
  tableCells: [
    {
      text: 'Date',
    },
    {
      text: 'Activity',
    },
    {
      text: 'Name',
    },
    {
      text: 'Buyer',
    },
    {
      text: 'Project',
    },
  ],
  tabCells: [
    {
      text: 'Date',
    },
    {
      text: 'Activity',
    },
    {
      text: 'Name',
    },
    {
      text: 'Buyer',
    },
    {
      text: 'Project',
    },
  ],
  actionFilters: {
    types: [
      { name: 'Target', key: 'target' },
      { name: 'Buyer', key: 'buyer' },
      { name: 'Exec', key: 'exec' },
      { name: 'LP', key: 'lp' },
    ],
    mailings: [
      { name: 'PM mailing', key: 'isletter' },
      { name: 'PM emails', key: 'isemail' },
      { name: 'All others', key: 'isnonpm' },
    ],
    activities: [
      { name: 'M1', key: 'm1' },
      { name: 'M2', key: 'm2' },
      { name: 'CM2', key: 'cm2' },
      { name: 'eM1', key: 'em1' },
      { name: 'eM2', key: 'em2' },
      { name: 'eCM2', key: 'ecm2' },
      { name: 'C_', key: 'cx' },
      { name: 'E_', key: 'ex' },
      { name: 'F_', key: 'fx' },
      { name: 'Call', key: 'call' },
      { name: 'Email', key: 'email' },
      { name: 'Fax', key: 'fax' },
      { name: 'CR', key: 'cr' },
      { name: 'KIT', key: 'kit' },
      { name: '(Custom)', key: 'custom' },
      { name: 'All others', key: 'other' },
    ],
  },
  actionList: [
    { name: 'Add Tag to Selected', attributes: {}, key: 'addTagToSelected' },
    {
      name: 'Set Next Action for Selected',
      attributes: {},
      key: 'setNextActionForSelected',
    },
    {
      name: 'Push Next Action Dates for Selected',
      attributes: {},
      key: 'pushNextActionDateForSelected',
    },
    {
      name: 'Add/Update Buyer for Selected',
      attributes: {},
      key: 'addUpdateBuyerForSelected',
    },
    {
      name: 'Flip Selected to Different Team',
      attributes: {},
      key: 'flipSelectedToDifferentTeam',
    },
    { name: 'Export Selected', attributes: {}, key: 'exportSelected' },
    { name: 'Delete Selected', attributes: { isDanger: true }, key: 'deleteSelected' },
    { name: 'Delete Selected', attributes: { isDanger: true }, key: 'deleteConfirmationSelected' },
    {
      name: 'Add Industry Tag to Selected Targets',
      attributes: {},
      key: 'addIndustryTagToSelected',
    },
    { name: 'Backlog selected', attributes: {}, key: 'backlogSelected' },
    { name: 'Run Windward Report', attributes: {}, key: 'runWindwardReport' },
    {
      name: 'Assign Trade Show to Selected Targets',
      attributes: {},
      key: 'assignTradeShowToSelected',
    },
    {
      name: 'Confirm merge',
      attributes: {},
      key: 'mergeConfirm',
    },
  ],
  company: {
    states: [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DE',
      'DC',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'PA',
      'PR',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VI',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
      'AB',
      'BC',
      'MB',
      'NB',
      'NL',
      'NS',
      'NT',
      'NU',
      'ON',
      'PE',
      'QC',
      'SK',
      'YT',
    ],
    entityTypes: [
      '',
      'Private',
      'DivPri',
      'LBO',
      'DivLBO',
      'Public',
      'DivPub',
      'VC',
      'DivVC',
      'ESOP',
      'NFP',
      'DivNFP',
      'Gov',
      'JV',
      'ForPri',
      'ForPub',
      'DivFor',
    ],
    parentCompanies: [
      '',
      'Private',
      'DivPri',
      'LBO',
      'DivLBO',
      'Public',
      'DivPub',
      'VC',
      'DivVC',
      'ESOP',
      'NFP',
      'DivNFP',
      'Gov',
      'JV',
      'ForPri',
      'ForPub',
      'DivFor',
    ],
    executive: {
      table: {},
    },
  },
  mailingLogs: {
    table: {
      columnDefs: [
        { headerName: 'Sent At', field: 'createdAt', width: 150, suppressSizeToFit: true, sortable: true },
        {
          headerName: 'Subject',
          field: 'subject',
          width: 150,
          sortable: true,
        },
        { headerName: 'Sent To', field: 'emailTo', width: 150, sortable: true },
        { headerName: 'Email Body', field: 'emailBody', width: 150, suppressSizeToFit: true, sortable: false },
        { headerName: 'Status', field: 'error', width: 150, suppressSizeToFit: true, sortable: true },
        { headerName: 'Attachments', field: 'attachments', width: 150, suppressSizeToFit: true, sortable: false },
      ],
    },
  },
  mailingHistory: {
    table: {
      columnDefs: [
        {
          headerName: 'Date',
          field: 'date',
          width: 100,
          suppressSizeToFit: true,
        },
        { headerName: '', field: 'icon', width: 40, suppressSizeToFit: true },
        {
          headerName: 'Activity',
          field: 'activity',
          width: 70,
          suppressSizeToFit: true,
        },
        { headerName: 'Module', field: 'recordOwnerUserName', width: 100 },
        { headerName: 'A/A', field: 'recordSubOwnerUserName', width: 100 },
        { headerName: 'Buyer (Type)', field: 'buyerLegalName', width: 100 },
        { headerName: 'Project', field: 'projectCategory', width: 100 },
        { headerName: '#', field: 'targetCount', width: 100 },
        { headerName: 'Is Sent', field: 'isSent', width: 100 },
      ],
    },
  },
  mailingCreate: {
    table: {
      columnDefs: [
        {
          headerName: '',
          field: 'selected',
          width: 36,
          suppressSizeToFit: true,
        },
        { headerName: 'Company Name', field: 'targetLegalName', width: 200 },
        { headerName: 'Web', field: 'targetWeb', width: 200 },
        {
          headerName: 'Next Action',
          field: 'naActivity',
          width: 100,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Next Action Date',
          field: 'naDate',
          width: 200,
          suppressSizeToFit: true,
        },
        { headerName: 'Email(Verified)', field: 'emailVerified', width: 50 },
        { headerName: 'Logos', field: 'logos', width: 40 },
      ],
    },
  },
  mailingInfo: {
    table: {
      columnDefs: [
        {
          headerName: 'NA',
          field: 'naActivity',
          width: 40,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Date',
          field: 'naDate',
          width: 80,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Company Name',
          field: 'targetLegalName',
          width: 120,
          editable: true,
          updateType: 'company',
          updateField: 'legal_name',
          suppressSizeToFit: true,
          cellStyle: { 'white-space': 'normal' },
        },
        {
          headerName: 'Abbrev. Name',
          field: 'targetAbbrName',
          width: 120,
          editable: true,
          updateType: 'company',
          updateField: 'abbr_name',
          suppressSizeToFit: true,
          cellStyle: { 'white-space': 'normal' },
        },
        {
          headerName: 'Rev.',
          field: 'targetRevenue',
          width: 40,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'company',
          updateField: 'revenue',
        },
        {
          headerName: 'Description',
          field: 'targetDescription',
          width: 220,
          editable: true,
          updateType: 'company',
          updateField: 'description',
          suppressSizeToFit: true,
          cellStyle: { 'white-space': 'normal' },
        },
        {
          headerName: 'Address',
          field: 'contactAddress',
          width: 180,
          editable: true,
          updateType: 'company',
          updateField: 'address',
          suppressSizeToFit: true,
          cellStyle: { 'white-space': 'normal' },
        },
        {
          headerName: 'City',
          field: 'contactCity',
          width: 100,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'company',
          updateField: 'city',
        },
        {
          headerName: 'State',
          field: 'contactState',
          width: 45,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Zip',
          field: 'contactZip',
          width: 50,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'company',
          updateField: 'zip',
        },
        {
          headerName: 'Country',
          field: 'contactCountry',
          width: 60,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Pref.',
          field: 'contactPrefix',
          width: 40,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'people',
          updateField: 'prefix',
        },
        {
          headerName: 'Contact First Name',
          field: 'contactFirstName',
          width: 125,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'people',
          updateField: 'first_name',
        },
        {
          headerName: 'Contact Last Name',
          field: 'contactLastName',
          width: 125,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'people',
          updateField: 'last_name',
        },
        {
          headerName: 'Sfx.',
          field: 'contactSuffix',
          width: 40,
          suppressSizeToFit: true,
          editable: true,
          updateType: 'people',
          updateField: 'suffix',
        },
        {
          headerName: 'Contact Title',
          field: 'contactTitle',
          width: 200,
          editable: true,
          updateType: 'contactTitle',
          updateField: 'title',
        },
        {
          headerName: 'Email',
          field: 'contactEmail',
          width: 200,
          editable: true,
          updateType: 'email',
          updateField: 'email',
        },
        {
          headerName: 'Web',
          field: 'targetWeb',
          width: 200,
          editable: true,
          updateType: 'company',
          updateField: 'web',
        },
        {
          headerName: 'Attachment',
          field: 'attachment',
          minWidth: 160,
        },
      ],
    },
    values: {
      footerDropDown: [
        {
          name: 'Project Template',
          onClickField: 'onProjectTemplate',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'Mailing Labels',
          onClickField: 'onMailingLabelsMerge',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'Download Merge Source',
          onClickField: 'onDownloadMergeSource',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'Quick Merge Source',
          onClickField: 'onQuickMergeSource',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'Download Logos',
          onClickField: 'onDownloadLogos',
          attributes: { 'aria-hidden': 'true' },
        },
        {
          name: 'Address Labels',
          onClickField: 'onAddressLabels',
          attributes: {
            'aria-hidden': 'true',
            className: 'disabled-link',
            disabled: true,
          },
        },
      ],
    },
  },
};

// Variables
config.API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
config.PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
config.PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
config.SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
config.PREVIOUS_VERSION_URL = process.env.REACT_APP_PREVIOUS_VERSION_URL;
config.NEW_VERSION_URL = process.env.REACT_APP_NEW_VERSION_URL;

config.main.offersAndBetterReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.offersAndBetterReport}`;
config.main.retainerReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.retainerReport}`;
config.main.leadsAndBetterReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.leadsAndBetterReport}`;
config.main.CCVisitReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.CCVisitReport}`;
config.main.OutreachReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.OutreachReport}`;
config.main.CeoOutreachReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.CeoOutreachReport}`;
config.main.activityReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.activityReport}`;
config.main.conflictReport = `${process.env.REACT_APP_API_BASE_URL}${config.main.conflictReport}`;
config.main.scraperExtensionLink = `${process.env.REACT_APP_API_BASE_URL}${config.main.scraperExtensionLink}`;
config.main.retainerHealth = `${process.env.REACT_APP_API_BASE_URL}${config.main.retainerHealth}`;
config.values.contact.vCardUrl = `${process.env.REACT_APP_API_BASE_URL}${config.values.contact.vCardUrl}`;

config.constants = fromJS(constants);
config.main = fromJS(config.main);
config.tables = fromJS(config.tables);
config.values = fromJS(config.values);
config.search = fromJS(config.search);
config.tabs = fromJS(config.tabs);
config.tableCells = fromJS(config.tableCells);
config.tabCells = fromJS(config.tabCells);
config.actionFilters = fromJS(config.actionFilters);
config.actionList = fromJS(config.actionList);
config.browse = fromJS(config.browse);
config.mailingHistory = fromJS(config.mailingHistory);
config.mailingCreate = fromJS(config.mailingCreate);
config.mailingInfo = fromJS(config.mailingInfo);
config.mailingLogs = fromJS(config.mailingLogs);
config.permisionError = List(["You don't have enough privilege to access this page"]);
config.noteBoxSize = Map({
  min: 200,
  default: 350,
});
config.eventPopupSize = {
  width: 670,
  height: 600,
  minConstraints: [500, 600],
};
config.createEmailTemplatePopupSize = {
  width: 700,
  height: 300,
  minConstraints: [500, 300],
};
// Request throttling
config.REQUEST_THROTTLING = 50;
config.NEXT_ACTION_REQUEST_THROTTLING = 1000;
config.NUMBER_OF_MIN_CHARACTER = 2;

config.VIEW_MODE = 'view';
config.EDIT_MODE = 'edit';
config.SUGGEST_MODE = 'suggest';
config.LOADING_MODE = 'loading';

// Variables
config.API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// TODO: use process.env
config.GOOGLE_API_KEY = 'AIzaSyC2fgI8v3-pjcX-Mz-pNw-SjuhA-D1Cjq8';

// User roles
config.RESEARCHER = RESEARCHER;
config.RESEARCH_INTERN = RESEARCH_INTERN;
config.JUNIOR_ANALYST = JUNIOR_ANALYST;
config.PROCESS_MANAGER = PROCESS_MANAGER;
config.ANALYST_ASSOCIATE = ANALYST_ASSOCIATE;
config.DIRECTOR = DIRECTOR;
config.ADMINISTRATOR = ADMINISTRATOR;
config.FINANCE_ADMIN = FINANCE_ADMIN;

config.phoneValidation = {
  title: 'Phone',
  description:
    'should be empty or valid format (111-111-1111 x[extension] or +[numbers, spaces and dashes] x[extension])',
  anyOf: [
    { type: 'null' },
    { type: 'string', pattern: /^$/ },
    { type: 'string', pattern: /^\d{3}-\d{3}-\d{4}(\s+(x|X) {1}\d+)?$/ },
    { type: 'string', pattern: /^\+[\d\s-]+(\s+(x|X) {1}\d+)?$/ },
  ],
};

config.contactPhoneValidation = {
  title: 'Phone',
  description: 'should be empty or should be a valid format (111-111-1111) or +[numbers, spaces and dashes]',
  anyOf: [
    { type: 'string', pattern: /^$/ },
    { type: 'string', pattern: /^\d{10}?$/ },
    { type: 'string', pattern: /^1\d{10}?$/ },
  ],
};

config.HAS_PARENT_COMPANY = ['DivPri', 'DivLBO', 'DivPub', 'DivVC', 'DivNFP', 'JV', 'DivFor'];

export default config;
